import { render } from "./LogNote.vue?vue&type=template&id=560bef96"
import script from "./LogNote.vue?vue&type=script&lang=js"
export * from "./LogNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__